module.exports = __webpack_public_path__ + "static/media/loader.f4404720.gif";